import api from "./API";

export const addevent = (url, ad, eventname, eventid) => {
  return api.post("https://www.hugfb.com/api/Events/addevent", {
    url,
    ad,
    eventname,
    eventid,
  });
};
